module.exports = __webpack_public_path__ + "static/media/contact.23643e90.jpg";